module.exports = __webpack_public_path__ + "img/valentine_profile.f62d41d7.jpg";